import React, { useState } from "react";
import { Card, Table, Button, Badge, Spinner, Modal } from "react-bootstrap"; 
import { FaPlus, FaTrash, FaEye, FaExclamationTriangle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useGetChamps } from "../../../hooks/CHAMPS/useGetChamps";
import { useDeleteChamp } from "../../../hooks/CHAMPS/useChampsActions";
import { toast } from "react-toastify";
import NewChampModal from "../../Modals/Create/NewChamp";

const ChampsTab = () => {
  const navigate = useNavigate();
  const { data, isLoading, isError } = useGetChamps();
  const deleteChampMutation = useDeleteChamp();
  
  const [showNewModal, setShowNewModal] = useState(false);
  
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedChamp, setSelectedChamp] = useState(null);

  const champs = (data?.data || []).filter((champ) => champ.is_active);


  const confirmDelete = (champ) => {
    setSelectedChamp(champ);
    setShowDeleteModal(true);
  };

 
  const handleDelete = () => {
    if (!selectedChamp) return;

    deleteChampMutation.mutate(selectedChamp.id, {
      onSuccess: () => {
        toast.success("Champ supprimé avec succès");
        setShowDeleteModal(false);
      },
      onError: (error) => {
        toast.error(error.message || "Erreur lors de la suppression");
        setShowDeleteModal(false);
      },
    });
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h5 className="mb-0">Gestion des champs personnalisés</h5>
        <Button variant="warning" onClick={() => setShowNewModal(true)}>
          <FaPlus className="me-2" />
          Nouveau champ
        </Button>
      </div>

      <Card className="shadow">
        <Card.Body>
          {isLoading ? (
            <div className="text-center py-5">
              <Spinner animation="border" role="status" style={{ color: "#f6c23e" }}>
                <span className="visually-hidden">Chargement...</span>
              </Spinner>
            </div>
          ) : isError ? (
            <div className="alert alert-danger">
              Erreur lors du chargement des champs personnalisés
            </div>
          ) : (
            <Table striped hover responsive>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Label</th>
                  <th>Nom de colonne</th>
                  <th>Type</th>
                  <th>Statut</th>
                  <th>Requis</th>
                  <th>Actif</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {champs.length === 0 ? (
                  <tr>
                    <td colSpan={8} className="text-center">
                      Aucun champ personnalisé
                    </td>
                  </tr>
                ) : (
                  champs.map((champ) => (
                    <tr key={champ.id}>
                      <td>{champ.id}</td>
                      <td>{champ.label}</td>
                      <td>
                        <code>{champ.column_name}</code>
                      </td>
                      <td>
                        {champ.field_type ? (
                          <Badge bg="info">{champ.field_type.label}</Badge>
                        ) : (
                          <span className="text-muted">-</span>
                        )}
                      </td>
                      <td>
                        {champ.field_apply_status ? (
                          <Badge bg="secondary">{champ.field_apply_status}</Badge>
                        ) : (
                          <span className="text-muted">-</span>
                        )}
                      </td>
                      <td className="text-center">
                        <Badge bg={champ.is_required ? "success" : "secondary"}>
                          {champ.is_required ? "Oui" : "Non"}
                        </Badge>
                      </td>
                      <td className="text-center">
                        <Badge bg={champ.is_active ? "success" : "danger"}>
                          {champ.is_active ? "Actif" : "Inactif"}
                        </Badge>
                      </td>
                      <td>
                        <div className="d-flex gap-2">
                          <Button
                            variant="primary"
                            size="sm"
                            onClick={() => navigate(`/administration-champs/${champ.id}`)}
                            title="Voir les détails"
                          >
                            <FaEye />
                          </Button>
                          <Button
                            variant="danger"
                            size="sm"
                            onClick={() => confirmDelete(champ)} 
                            disabled={deleteChampMutation.isPending}
                            title="Supprimer"
                          >
                            <FaTrash />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>

    
      <NewChampModal show={showNewModal} setShow={setShowNewModal} />


      <Modal 
        show={showDeleteModal} 
        onHide={() => setShowDeleteModal(false)} 
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-danger">
            <FaExclamationTriangle className="me-2" />
            Confirmation de suppression
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Êtes-vous sûr de vouloir supprimer le champ <strong>"{selectedChamp?.label}"</strong> ? 
          <br />
          <small className="text-muted">Cette action peut être irréversible.</small>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => setShowDeleteModal(false)}>
            Annuler
          </Button>
          <Button 
            variant="danger" 
            onClick={handleDelete}
            disabled={deleteChampMutation.isPending}
          >
            {deleteChampMutation.isPending ? <Spinner size="sm" className="me-1"/> : null}
            Supprimer définitivement
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ChampsTab;